module.exports = __webpack_public_path__ + "static/img/medication.03fb7a2f.png";